/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en acciones críticas
* --------------------------------------------------------------------------------------- */

import { Fragment, useEffect, useRef } from 'react';
import { Box, Grid, IconButton, Tooltip, ClickAwayListener, Typography } from '@mui/material';
import { useDoubleClickPrevention } from '../../../hooks/useDoubleClickPrevention';
import CloseIcon from '@mui/icons-material/Close';
import DirectionsIcon from '@mui/icons-material/Directions';
import AddIcon from "@mui/icons-material/Add";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import SearchIcon from '@mui/icons-material/Search';
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VerifiedIcon from "@mui/icons-material/Verified";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import SaveIcon from '@mui/icons-material/Save';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import RefreshIcon from "@mui/icons-material/Refresh";
import PrintIcon from '@mui/icons-material/Print';
import NextPlanIcon from '@mui/icons-material/NextPlan';
import HomeIcon from '@mui/icons-material/Home';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import SizeSoftXModal from "../../leyout/SizeSoftXModal.jsx";

import { useSesion } from "../../../context/System/SesionContext"
import { useArticulos } from "../../../context/Catalogos/ArticulosContext";
import { useInventarios } from '../../../context/Inventarios/InventariosContext.js';

export default function MnuArticulosActions({ onOpenTenantSync }) {
    const { getVisualizacionBoton } = useSesion();
    const fileInputRef = useRef();
    const {
        handleClickRefrescarDatos,
        handleClickRegresarMainDashboard,
        handleClickNuevoArticulo,
        handleClickEditarArticulo,
        handleClickGuardarArticulo,
        handleClickEliminarArticulo,
        handleUploadImage,
        handleAbrirBuscarArticulo,
        statusEditArticulo,
        handleClickDeshacer,
        handleClonarArticulo,
        articuloSeleccionado,
        statusEditable, setStatusEditable,
        statusOpenModalEliminarArticulo, setStatusOpenModalEliminarArticulo,
    } = useArticulos();
    

    const {setDataFiltroExistencias} = useInventarios();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    useEffect(()=>{
        if(articuloSeleccionado.clavearticulo == "" || articuloSeleccionado.clavearticulo == null)
            setStatusEditable(true);
        else    
            setStatusEditable(false);
    },[articuloSeleccionado.clavearticulo]);

    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon">Salir</p>
                </IconButton>
            </Tooltip>
            <Tooltip title={'Nuevo'}>
                <IconButton disabled={!statusEditArticulo || isProcessing} onClick={() => executeWithProtection(handleClickNuevoArticulo)}>
                    <AddIcon className="icon" /><p className="icon">Nuevo</p>
                </IconButton>
            </Tooltip>            
            <Tooltip title={!statusEditArticulo ? 'Guardar' : 'Editar'}>
                <IconButton disabled={(statusEditArticulo && statusEditable) || isProcessing}
                    onClick={() => executeWithProtection(!statusEditArticulo ? handleClickGuardarArticulo : handleClickEditarArticulo)}>
                    {!statusEditArticulo ? <SaveIcon className="icon" /> : <EditIcon className="icon" />}
                    <p className="icon">{!statusEditArticulo ? 'Guardar' : 'Editar'}</p>
                </IconButton>
            </Tooltip>
            <Tooltip title="Cargar foto">
                <>
                    {/* Input oculto */}
                    <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleUploadImage}
                    />
                    
                    {/* Botón que dispara el input */}
                    <IconButton  disabled={statusEditArticulo || isProcessing}
                        onClick={() => fileInputRef.current && fileInputRef.current.click()}
                    >
                        <SaveIcon className="icon" />
                        <p className="icon">Cargar foto</p>
                    </IconButton>
                </>
            </Tooltip>
            <Tooltip title={'Eliminar'} >
                <IconButton disabled={statusEditArticulo || isProcessing} onClick={() => executeWithProtection(() => setStatusOpenModalEliminarArticulo(true))}>
                    <DeleteIcon className="icon" /><p className="icon">Eliminar</p>
                </IconButton>
            </Tooltip>            
            <Tooltip title={'Deshacer'} >
                <IconButton disabled={isProcessing || (statusEditArticulo && articuloSeleccionado.clavearticulo === "")} onClick={()=> {executeWithProtection(() => { handleClickDeshacer(); setDataFiltroExistencias([]); }); }}>
                    <DeleteIcon className="icon" /><p className="icon">Deshacer</p>
                </IconButton>
            </Tooltip>  
            <Tooltip title={'Clonar'}>
                <IconButton disabled={!articuloSeleccionado.clavearticulo || articuloSeleccionado.clavearticulo.trim() === "" || isProcessing} onClick={() => executeWithProtection(handleClonarArticulo)}>
                    <ContentCopyIcon className="icon" /><p className="icon">Clonar</p>
                </IconButton>
            </Tooltip>  
            <Tooltip title="Refrescar">
                <IconButton onClick={handleClickRefrescarDatos}>
                    <RefreshIcon className="icon" />
                </IconButton>
            </Tooltip> 
            <Tooltip title="Sincronizar articulo con otras tiendas">
                <span>
                    <IconButton disabled={!articuloSeleccionado.clavearticulo || !statusEditArticulo} onClick={onOpenTenantSync}>
                        <SyncAltIcon className="icon" /><p className="icon">Sincronizar</p>
                    </IconButton>
                </span>
            </Tooltip>
            <Tooltip title={"Artículos"}>
                <IconButton onClick={handleAbrirBuscarArticulo} >
                    <SearchIcon className="icon" /><p className="icon">Artículos</p>
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
